/* SESH homepage carousel v2. Only the unpublished 22 Oct UX theme uses this asset. */
(function () {
  'use strict';
  function init(root) {
    if (!root || root.dataset.seshHeroV2 === 'ready') return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-skh-slide]'));
    if (!slides.length) return;
    root.dataset.seshHeroV2 = 'ready';
    var current = slides.findIndex(function (slide) { return slide.classList.contains('is-active'); });
    if (current < 0) current = 0;
    var interval = 7000;
    var isAutoplay = Number(root.getAttribute('data-autoplay')) > 0;
    var timer = null;
    var focused = false;
    var hovered = false;
    var touching = false;
    var drag = null;
    var ignoreClickUntil = 0;

    function preloadAdjacent() {
      if (slides.length < 2) return;
      var next = slides[(current + 1) % slides.length];
      var nextImage = next.querySelector('img');
      if (nextImage) nextImage.loading = 'eager';
    }
    function pause() {
      if (timer !== null) {
        clearTimeout(timer);
        timer = null;
      }
    }
    function canPlay() {
      return isAutoplay && slides.length > 1 && !document.hidden && !hovered && !focused && !touching;
    }
    function schedule() {
      pause();
      if (!canPlay()) return;
      timer = setTimeout(function () {
        goTo(current + 1);
      }, interval);
    }
    function goTo(index) {
      current = ((index % slides.length) + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var active = i === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if ('inert' in slide) slide.inert = !active;
      });
      preloadAdjacent();
      schedule();
    }
    function swiped(dx, dy) {
      var threshold = Math.max(38, Math.min(70, root.clientWidth * .09));
      if (Math.abs(dx) < threshold || Math.abs(dx) <= Math.abs(dy) * 1.2) return false;
      ignoreClickUntil = Date.now() + 800;
      goTo(current + (dx < 0 ? 1 : -1));
      return true;
    }
    root.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1) return;
      touching = true;
      drag = { x: event.touches[0].clientX, y: event.touches[0].clientY, kind: 'touch' };
      pause();
    }, { passive: true });

    root.addEventListener('touchend', function (event) {
      if (drag && drag.kind === 'touch' && event.changedTouches.length) {
        var p = event.changedTouches[0];
        swiped(p.clientX - drag.x, p.clientY - drag.y);
      }
      drag = null;
      touching = false;
      schedule();
    }, { passive: true });
    root.addEventListener('touchcancel', function () {
      drag = null;
      touching = false;
      schedule();
    }, { passive: true });

    root.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch' || (event.pointerType === 'mouse' && event.button !== 0)) return;
      drag = { x: event.clientX, y: event.clientY, kind: 'pointer' };
      touching = true;
      pause();
    });
    root.addEventListener('pointerup', function (event) {
      if (!drag || drag.kind !== 'pointer') return;
      swiped(event.clientX - drag.x, event.clientY - drag.y);
      drag = null;
      touching = false;
      schedule();
    });
    root.addEventListener('pointercancel', function () {
      if (drag && drag.kind === 'pointer') drag = null;
      touching = false;
      schedule();
    });
    root.addEventListener('click', function (event) {
      if (Date.now() < ignoreClickUntil) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);

    /* Touchscreens can synthesize mouseenter. Pause for hover only on real hover-capable devices. */
    var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    root.addEventListener('mouseenter', function () { if (!canHover) return; hovered = true; pause(); });
    root.addEventListener('mouseleave', function () { if (!canHover) return; hovered = false; schedule(); });
    root.addEventListener('focusin', function () { focused = true; pause(); });
    root.addEventListener('focusout', function () {
      setTimeout(function () {
        focused = root.contains(document.activeElement);
        schedule();
      }, 0);
    });
    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(current + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    document.addEventListener('visibilitychange', schedule);
    root.setAttribute('aria-live', 'off');
    goTo(current);
  }
  function boot(scope) {
    var context = scope || document;
    if (context.matches && context.matches('[data-skh-clean]')) init(context);
    context.querySelectorAll('[data-skh-clean]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target && event.target.closest && event.target.closest('[data-skh-slide]');
    if (!slide) return;
    var root = slide.closest('[data-skh-clean]');
    if (!root) return;
    /* Theme editor block selection is handled by Shopify preview; no visible controls required. */
  });
})();
